import React from "react";
import { Link, useNavigate } from "react-router-dom";
import EmptyTableMessage from "../../../components/table/EmptyTableMessage.js";
import { formatCurrency } from "../../../utils/utils_number.js";

const tipo_pago = {
  1: "EFECTIVO",
  2: "CHEQUE",
  3: "TRANSFERENCIA",
};

const PagosComprobanteTable = ({ comprobante }) => {
  const { id: comprobante_id, estado } = comprobante;
  const navigate = useNavigate();

  return (
    <div>
      <div className="col-12 d-flex justify-content-end">
        <button
          className="btn btn-lime btn-md ms-5px mb-2"
          disabled={estado === "pagada" || estado === "invalidada"}
          onClick={() => navigate(`/venta/pago?ids_comprobantes=${comprobante_id}`)}
        >
          Registrar nuevo abono
        </button>
      </div>
      <div className="table-responsive shadow">
        <table className="table table-thead-sticky table-tfoot-sticky table-tbody-bordered table-px-10px table-py-4px table-sm table-striped text-nowrap mb-0">
          <thead>
            <tr className="text-nowrap">
              <th>#</th>
              <th>PAGO</th>
              <th>FECHA</th>
              <th>Referencia</th>
              <th>TIPO PAGO</th>
              <th className="text-end">MONTO</th>
            </tr>
          </thead>
          <tbody>
            {comprobante?.pagos?.length > 0 ? (
              comprobante.pagos.map((cp, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>
                    <Link to={`/venta/pago?id_pago=${cp.id}`} className="fw-bold text-nowrap">
                      PAGO-{cp.id}
                    </Link>
                  </td>
                  <td>{cp.fecha_pago}</td>

                  {cp.referencia ? (
                    <td className="breakWord">{cp.referencia}</td>
                  ) : (
                    <td className="text-center p-3 text-muted">[ SIN REFERENCIA ]</td>
                  )}

                  <td>{tipo_pago[cp.id_tipopago]}</td>
                  <td className="text-nowrap text-end">{formatCurrency(cp.ComprobantePago.monto_aplicado)}</td>
                </tr>
              ))
            ) : (
              <>
                <EmptyTableMessage columns={6} />
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="row p-2">
        <div className="col-6 col-md-8   text-end text-gray">YA PAGADO: </div>
        <div className="col-6 col-md-4 fw-bold text-end">
          {formatCurrency(Number(comprobante?.totalPagar || 0) - Number(comprobante?.pendiente || 0))}
        </div>
      </div>
      <div className="row p-2">
        <div className="col-6 col-md-8   text-end text-gray">( - ) FACTURADO: </div>
        <div className="col-6 col-md-4 fw-bold text-end">{formatCurrency(comprobante?.totalPagar)}</div>
      </div>
      <div className="row p-2 fs-2">
        <div className="col-6 col-md-8 fw-bold text-end">RESTA POR PAGAR: </div>
        <div className="col-6 col-md-4 fw-bold text-end text-red-600">{formatCurrency(comprobante?.pendiente)}</div>
      </div>
    </div>
  );
};

export default PagosComprobanteTable;
